import { render, staticRenderFns } from "./PaymentDetailTitle.vue?vue&type=template&id=0d4f2004"
import script from "./PaymentDetailTitle.vue?vue&type=script&lang=js"
export * from "./PaymentDetailTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports